import {Store} from 'effector'
import {h, spec} from 'forest'
import {Border} from './index.h'
import {CELL} from './env'

export function border({
  borderSize,
  color,
  dataTag
}: {
  borderSize: Store<Border>
  color: string
  dataTag?: Store<string>
}) {
  const strokeWidth = 4
  const translate = borderSize.map(
    ({x, y}) => `translate(${x * CELL} ${y * CELL})`
  )
  const width = borderSize.map(({width}) => width * CELL - strokeWidth * 2)
  const height = borderSize.map(({height}) => height * CELL - strokeWidth * 2)
  h('g', {
    attr: {
      transform: translate
    },
    fn() {
      if (dataTag) {
        spec({
          data: {tag: dataTag}
        })
      }
      h('rect', {
        attr: {
          x: strokeWidth,
          y: strokeWidth,
          width,
          height,
          fill: 'transparent',
          stroke: color,
          'stroke-width': strokeWidth / 2,
          rx: 10
        }
      })
    }
  })
}
